import React from 'react';
import { Field } from 'react-final-form';

import { requiredFieldArrayCheckbox } from '../../../util/validators';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './TermsAndConditions.module.css';

const TERMS_VALUE = 'tos-and-privacy';

/**
 * A component that renders the terms and conditions acceptance checkbox.
 *
 * @component
 * @param {Object} props
 * @param {string} props.formId - The form id
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const TermsAndConditions = props => {
  const { formId, intl } = props;
  const inputId = formId ? `${formId}.terms-accepted` : 'terms-accepted';
  const validate = requiredFieldArrayCheckbox(
    intl.formatMessage({ id: 'AuthenticationPage.termsAndConditionsAcceptRequired' })
  );

  return (
    <Field
      name="terms"
      type="checkbox"
      value={TERMS_VALUE}
      validate={validate}
    >
      {({ input }) => (
        <div className={css.root}>
          <label htmlFor={inputId} className={css.label}>
            <input
              {...input}
              id={inputId}
              type="checkbox"
              value={TERMS_VALUE}
              className={css.input}
            />
            <span className={css.finePrint}>
              J'accepte les{' '}
              <a
                href="/terms-of-service"
                target="_blank"
                rel="noopener noreferrer"
                className={css.termsLink}
              >
                <FormattedMessage id="AuthenticationPage.termsAndConditionsTermsLinkText" />
              </a>
              {' '}et la{' '}
              <a
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className={css.privacyLink}
              >
                <FormattedMessage id="AuthenticationPage.termsAndConditionsPrivacyLinkText" />
              </a>
              {', '}
              <FormattedMessage id="AuthenticationPage.termsAndConditionsLoyaltyText" values={{
                link: (
                  <a
                    href="/programme-fidelite"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={css.termsLink}
                  >
                    <FormattedMessage id="AuthenticationPage.termsAndConditionsLoyaltyLinkText" />
                  </a>
                ),
              }} />
            </span>
          </label>
        </div>
      )}
    </Field>
  );
};

export default TermsAndConditions;
